import { render, staticRenderFns } from "./TotalSummary.vue?vue&type=template&id=6f2e0621&scoped=true"
import script from "./TotalSummary.vue?vue&type=script&lang=js"
export * from "./TotalSummary.vue?vue&type=script&lang=js"
import style0 from "./TotalSummary.vue?vue&type=style&index=0&id=6f2e0621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e0621",
  null
  
)

export default component.exports